import { render } from "./CustomersOrdersCard.vue?vue&type=template&id=212648ee&scoped=true"
import script from "./CustomersOrdersCard.vue?vue&type=script&lang=js"
export * from "./CustomersOrdersCard.vue?vue&type=script&lang=js"

import "./CustomersOrdersCard.vue?vue&type=style&index=0&id=212648ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212648ee"]])

export default __exports__